 // The build system defaults to the dev environment which uses `environment.ts`, but if you do
 // `ng build --env=prod` then `environment.prod.ts` will be used instead.
 // The list of which env maps to which file can be found in `angular-cli.json`.

 const APP_URL = location.protocol + "//" + location.hostname + (location.port ? ":" + location.port : "");
 const OAUTH_REDIRECT_URL = APP_URL + "/services";

 export const environment = {
   APP_URL,
   KEYCLOAK_ACTIVE: "KEYCLOAK_ACTIVE_PLACEHOLDER",
   KEYCLOAK_URL: "KEYCLOAK_URL_PLACEHOLDER",
   KEYCLOAK_REALM: "KEYCLOAK_REALM_PLACEHOLDER",
   KEYCLOAK_INSTITUTIONS_GROUP_ID: "KEYCLOAK_INSTITUTIONS_GROUP_ID_PLACEHOLDER",
   OAUTH_REDIRECT_URL,
   OAUTH_CLIENT_ID: "OAUTH_CLIENT_ID_PLACEHOLDER",
   OAUTH_SECRET: "OAUTH_SECRET_PLACEHOLDER",
   PRODUCTION: false,
   DEFAULT_LANGUAGE: "DEFAULT_LANGUAGE_PLACEHOLDER",
   BASE_URL: "BASE_URL_PLACEHOLDER",
   CAS_URL: "CAS_URL_PLACEHOLDER",
   PARTC_URL: "PARTC_URL_PLACEHOLDER",
   E_REGISTRATIONS_URL: "E_REGISTRATIONS_URL_PLACEHOLDER",
   GDB_URL: "GDB_URL_PLACEHOLDER",
   E_REGISTRATIONS_HOME_URL: "E_REGISTRATIONS_HOME_URL_PLACEHOLDER",
   RESTHEART_URL: "RESTHEART_URL_PLACEHOLDER",
   APP_TITLE: "APP_TITLE_PLACEHOLDER",
   LOCAL: false,
   WS_URL: APP_URL.replace(/https?/, "wss") + "/wssbe",
   UPLOAD_MAX_FILE_SIZE: 16 * 1024 * 1024,
   DIGITAL_SIGNATURE_COMPONENT_ENABLED: "DIGITAL_SIGNATURE_COMPONENT_ENABLED_PLACEHOLDER",
   INPUT_TRANSFORMATIONS_ENABLED: "INPUT_TRANSFORMATIONS_ENABLED_PLACEHOLDER",
   EREGISTRATIONS_VERSION: "EREGISTRATIONS_VERSION_PLACEHOLDER",
   BUILD_TYPE: "BUILD_TYPE_PLACEHOLDER",
   HIDE_PREVIEW: "HIDE_PREVIEW_PLACEHOLDER",
   CATALOGS_LIMIT_TO_ENFORCE: "CATALOGS_LIMIT_TO_ENFORCE_PLACEHOLDER",
   USE_NEW_DS: "USE_NEW_DS_PLACEHOLDER",
 };
